import { render, staticRenderFns } from "./PrintOverdueBalancesCustomer.vue?vue&type=template&id=3d38f0cc&scoped=true"
import script from "./PrintOverdueBalancesCustomer.vue?vue&type=script&lang=js"
export * from "./PrintOverdueBalancesCustomer.vue?vue&type=script&lang=js"
import style0 from "./PrintOverdueBalancesCustomer.vue?vue&type=style&index=0&id=3d38f0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d38f0cc",
  null
  
)

export default component.exports